// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-indicator_wrapper__28Oai"};